import { useLayoutEffect } from 'react';

export const useAutoResize = (ref) => {
  useLayoutEffect(() => {
    const textarea = ref.current;
    const resize = () => {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    };
    resize();
    textarea.addEventListener('input', resize);
    return () => {
      textarea.removeEventListener('input', resize);
    };
  }, [ref]);
};
